export const states = ['VIC', 'NSW', 'ACT', 'QLD', 'SA', 'WA', 'TAS', 'NT']
